import React from "react";
import TextField from "@material-ui/core/TextField";
import InputAdornment from "@material-ui/core/InputAdornment";
import Link from "@material-ui/core/Link";
import MailOutlineIcon from "@material-ui/icons/MailOutline";
import { Typography } from "@material-ui/core";
import { positioningElems } from "../../../config/theme";

export const emailRenderer = (
    value,
    name,
    fieldUpdateHandler,
    isError,
    mutable,
    editable,
) => {
    if (!value && typeof fieldUpdateHandler === "function" && mutable) {
        // creating data
        return (
            <TextField
                error={!!isError}
                helperText={isError}
                value={value || ""}
                onChange={(e) => fieldUpdateHandler(name, e.target.value)}
                InputProps={
                    !value || value.length === 0
                        ? {}
                        : {
                              endAdornment: (
                                  <InputAdornment position="end">
                                      <Link
                                          href={"mailto:" + value}
                                          target="_blank"
                                          rel="noopener"
                                      >
                                          <MailOutlineIcon />
                                      </Link>
                                  </InputAdornment>
                              ),
                          }
                }
            />
        );
    } else if (
        value &&
        typeof fieldUpdateHandler === "function" &&
        editable !== false &&
        mutable
    ) {
        // updatig data
        return (
            <TextField
                error={!!isError}
                helperText={isError}
                value={value || ""}
                onChange={(e) => fieldUpdateHandler(name, e.target.value)}
                InputProps={
                    !value || value.length === 0
                        ? {}
                        : {
                              endAdornment: (
                                  <InputAdornment position="end">
                                      <Link
                                          href={"mailto:" + value}
                                          target="_blank"
                                          rel="noopener"
                                      >
                                          <MailOutlineIcon />
                                      </Link>
                                  </InputAdornment>
                              ),
                          }
                }
            />
        );
    } else if (value && editable === false) {
        // view data when editable === false
        return (
            <Typography
                children={[
                    <span
                        key={"address"}
                        style={positioningElems.inlineWithIcon}
                    >
                        {value}
                    </span>,
                    <Link
                        key={"link"}
                        href={"mailto:" + value}
                        target="_blank"
                        rel="noopener"
                    >
                        <MailOutlineIcon
                            style={positioningElems.distanceToIcon}
                        />
                    </Link>,
                ]}
            />
        );
    } else if (value && !mutable) {
        // view data without editable parameter
        return (
            <Typography
                children={[
                    <span
                        key={"address"}
                        style={positioningElems.inlineWithIcon}
                    >
                        {value}
                    </span>,
                    <Link
                        key={"link"}
                        href={"mailto:" + value}
                        target="_blank"
                        rel="noopener"
                    >
                        <MailOutlineIcon
                            style={positioningElems.distanceToIcon}
                        />
                    </Link>,
                ]}
            />
        );
    } else {
        // to prevent crashes
        return [];
    }
};
